import EA from 'helpers/init';

export default EA.Methods.addActive = ($this) => {
    const btns = $this.querySelectorAll('.toggle-active');

    btns.forEach(btn => {
        btn.addEventListener('click', () =>  {
            const hiddenContent = btn.nextSibling;

            if (!hiddenContent.classList.contains('active')) {
                btn.parentElement.classList.add('active');
                hiddenContent.classList.add('active');
            } else {
                btn.parentElement.classList.remove('active');
                hiddenContent.classList.remove('active');
            }
        });
    });
}